import { isStaging } from '@/utils/isStaging';

import { webCampaign } from './webCampaign';

// Global flags to track if events have been sent
let hasSentViewItemEvent = false;
let hasSentAddToCartEvent = false;
let hasSentBeginCheckoutEvent = false;

export class AxonModule {
  private static isEnabled(): boolean {
    return webCampaign.isAxonTrackingEnabled();
  }

  public static hasSentViewItem(): boolean {
    return hasSentViewItemEvent;
  }

  public static setViewItemSent(): void {
    hasSentViewItemEvent = true;
  }

  public static hasSentAddToCart(): boolean {
    return hasSentAddToCartEvent;
  }

  public static setAddToCartSent(): void {
    hasSentAddToCartEvent = true;
  }

  public static hasSentBeginCheckout(): boolean {
    return hasSentBeginCheckoutEvent;
  }

  public static setBeginCheckoutSent(): void {
    hasSentBeginCheckoutEvent = true;
  }

  /**
   * Tracks page_view event
   * @param userId - Optional user ID to enrich payload with user_data
   */
  public static trackPageView(userId: string | null = null): void {
    if (!this.isEnabled()) return;

    this.pushEvent('page_view', 'axon_page_view', {}, userId);
  }

  /**
   * Pushes event to dataLayer with optional user enrichment
   * @param eventName - Name of the event
   * @param payloadKey - Key for the payload in dataLayer
   * @param payload - Event payload
   * @param userId - Optional user ID to enrich payload with user_data
   */
  public static pushEvent(
    eventName: string,
    payloadKey: string,
    payload: unknown,
    userId: string | null = null,
  ): void {
    if (!this.isEnabled()) return;

    // Enrich payload with userId
    const isObjectPayload = typeof payload === 'object' && payload !== null;
    let enrichedPayload = payload;
    if (isObjectPayload && userId) {
      enrichedPayload = {
        ...(payload as Record<string, unknown>),
        user_data: {
          user_id: userId,
        },
      };
    }

    // In staging/development mode, only log events, don't send them
    if (isStaging()) {
      console.log('[Axon]', eventName, enrichedPayload);
      return;
    }

    // In production, send events to dataLayer
    if (!window.dataLayer) return;

    window.dataLayer.push({
      event: eventName,
      [payloadKey]: enrichedPayload,
    });
  }
}
